import React from 'react';
import { Avatar, Box } from '@mui/material';
import OnlineStatus from './OnlineStatus';

interface ChatAvatarProps {
  name: string;
  isOnline?: boolean;
  lastSeenAt?: string | null;
  size?: number;
  showStatus?: boolean;
}

const ChatAvatar: React.FC<ChatAvatarProps> = ({
  name,
  isOnline = false,
  lastSeenAt,
  size = 40,
  showStatus = true,
}) => {
  // Get initials from name
  const getInitials = (fullName: string) => {
    const parts = fullName.trim().split(' ');
    if (parts.length >= 2) {
      return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
    }
    return fullName.substring(0, 2).toUpperCase();
  };

  // Generate color from name
  const stringToColor = (str: string) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    const colors = [
      '#1976d2', '#388e3c', '#d32f2f', '#7b1fa2',
      '#c2185b', '#0288d1', '#00796b', '#f57c00',
      '#5d4037', '#455a64'
    ];
    return colors[Math.abs(hash) % colors.length];
  };

  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <Avatar
        sx={{
          width: size,
          height: size,
          fontSize: size * 0.4,
          backgroundColor: stringToColor(name),
          fontWeight: 500,
        }}
      >
        {getInitials(name)}
      </Avatar>
      {showStatus && (
        <Box
          sx={{
            position: 'absolute',
            bottom: 0,
            right: 0,
          }}
        >
          <OnlineStatus
            isOnline={isOnline}
            lastSeenAt={lastSeenAt}
            size={size > 35 ? 'medium' : 'small'}
          />
        </Box>
      )}
    </Box>
  );
};

export default ChatAvatar;
